//
//
export default [
  {
    name: "contractV2Public",
    path: "/contract/v2/:studioId",
    meta: {
      navbarTitle: "Online Abo",
      hideBottomNavigation: true,
      hideAvatar: true,
      hideLogo: true,
      hideAppBar: true,
      fullWidth: true,
      contractV2Public: true,
    },
    component: () => import(/* webpackChunkName: "contract-v2" */ "@/views/dashboard/contract/contractV2.vue"),
  },
  {
    name: "contractCreatorExtern",
    path: "/contract",
    meta: {
      navbarTitle: "Chat", // Titel für deine App-Bar
      hideBottomNavigation: true, // Oder true, je nachdem
      hideAvatar: true,
      hideLogo: true,
      hideAppBar: true,
      fullWidth: true, // Lässt den Chat die volle Breite nutzen
    },
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreatorExtern.vue"),
  },
  {
    name: "contractCreatorExternForm",
    path: "/contract/create/:id/:studioId",
    // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractCreator.vue"),
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
  {
    name: "contractCreatorExternFormNew",
    path: "/contract/createnew/:id/:studioId",
    // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractCreator.vue"),
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator_new.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
  {
    name: "contractCreatorExternForm",
    path: "/contract/create/:id/:studioId/:skipPresale",
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
  {
    name: "contractCreatorExternFormNew",
    path: "/contract/createnew/:id/:studioId/:skipPresale",
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator_new.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
]
